import { apiClient } from "../api/apiClient.js";

/**
 * Thin wrapper around POST /api/auth/login (resolved through the runtime
 * authBaseUrl, never a hardcoded URL). Returns the parsed response body -
 * { token, expiresAtUtc, user, roles } - or throws ApiClientError on
 * failure. Never logs the identifier/password anywhere; apiClient itself
 * already never includes the request body in thrown errors.
 */
export function login(identifier, password) {
  return apiClient.post("/login", { identifier, password }, { base: "auth" });
}
